export default "__VITE_ASSET__8bc56903__"